import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import logo from './images.jpeg';
import vendor from './ven.jpg';
import member from './mem.jpg';
import food from './food.jpg';
import banner from './ban.png';
import fav from './fav.png';
import maghil from './logo.png';

function App() {
  return (
    <div className="App">
      <div className="parallax-bg"></div>
      <div className="content-wrapper">
        <header className="header">
          <div className="container">
            <div className="logo-container">
              <img src={logo} alt="Tamil Sangam Logo" className="logo" />
            </div>
            <h1 className="main-title">Chithirai Thiruvizha 2025</h1>
            <p className="subtitle">Celebrating Tamil Culture & Heritage</p>
            <div className="header-services">
              <a href="https://customerappbeta.web.app/restaurant/tamil-sangam-aubrey/menu/Pickup/event/chithirai-thiruvizha-ventors" target="_blank"><p className="service-text">Register as Vendor</p></a>
              <a href="https://customerappbeta.web.app/restaurant/tamil-sangam-aubrey/menu/Pickup/event/chithirai-thiruvizha-members" target="_blank"><p className="service-text">Add as Member</p></a>
              <a href="https://customerappbeta.web.app/restaurantat/tamil-sangam/e/chithirai-thiruvizha" target="_blank"><p className="service-text">Get Food Pre Book</p></a>
            </div>
          </div>
            <div className="scroll-indicator">
              <button 
                className="scroll-down-btn" 
                onClick={() => document.querySelector('.main-content').scrollIntoView({ behavior: 'smooth' })}
                aria-label="Scroll down to registration section"
              >
                <i className="fa-solid fa-angle-down"></i>
              </button>
            </div>
        </header>

      <main className="main-content">
        <div className="container">
          <h2 className="section-title">Event Registration & Services</h2>

          <div className="events-grid">
                <div className="row">
                  
                    <div className="col-12 col-sm-6 col-lg-4 mx-auto mb-4 img-event"
                    onClick={() => window.open('https://customerappbeta.web.app/restaurant/tamil-sangam-aubrey/menu/Pickup/event/chithirai-thiruvizha-ventors', '_blank')}
                    >
                        <div className="img-box">
                            <img src={vendor} className="img-fluid" alt="Event 1" />
                            <div className="event-details">
                                <p className="event-name mb-0">Vendor Registration</p>
                                <div className="underline mb-1"></div>
                                <p className="m-0 event-desc">Register as a vendor for the event</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-4 mx-auto mb-4 img-event"
                    onClick={() => window.open('https://customerappbeta.web.app/restaurant/tamil-sangam-aubrey/menu/Pickup/event/chithirai-thiruvizha-members', '_blank')}
                    >
                        <div className="img-box">
                            <img src={member} className="img-fluid" alt="Event 2" />
                            <div className="event-details">
                                <p className="event-name mb-0">Member Registration</p>
                                <div className="underline mb-1"></div>
                                <p className="m-0 event-desc">Join as a member of our community</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-4 mx-auto mb-4 img-event"
                    onClick={() => window.open('https://customerappbeta.web.app/restaurantat/tamil-sangam/e/chithirai-thiruvizha', '_blank')}
                    >
                        <div className="img-box">
                            <img src={food} className="img-fluid" alt="Event 3" />
                            <div className="event-details">
                                <p className="event-name mb-0">Food Pre-Booking</p>
                                <div className="underline mb-1"></div>
                                <p className="m-0 event-desc">Pre-book your delicious meals</p>
                            </div>
                        </div>
                    </div>
                </div>
          </div>

        </div>
      </main>

        <footer className="footer">
          <div className="container">
            <div className="footer-content text-center">
              <p className="footer-text">Copyright © 2025 Metroplex Tamil Sangam</p>
              <p className="footer-text">Powered by <a href="https://www.maghil.com" target="_blank" rel="noopener noreferrer">
              <img src={maghil} alt="Maghil" className="maghil-icon mb-2" /></a></p>
            </div>
          </div>
        </footer>

      </div>
    </div>
  );
}

export default App;
